import { DefaultComparator } from 'modules/queryBuilder/types';
import { UNSUBSCRIBED_MESSAGE_TYPE_REPLACEMENT_FEATURE_FLAG } from 'modules/queryBuilder/featureFlags';
import { SUBSCRIBED_MESSAGE_TYPES, UNSUBSCRIBED_MESSAGE_TYPES } from 'utils/fieldConstants';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';

export const useTransformToUnsubscribedMessageCondition = () => {
  const isFeatureFlagged = useFeatureFlag(
    UNSUBSCRIBED_MESSAGE_TYPE_REPLACEMENT_FEATURE_FLAG,
    false,
  );

  return <Condition extends Record<string, unknown>>(condition: Condition) => {
    return isFeatureFlagged &&
      condition.field === SUBSCRIBED_MESSAGE_TYPES &&
      condition.comparatorType === DefaultComparator.DOES_NOT_EQUAL
      ? {
          ...condition,
          field: UNSUBSCRIBED_MESSAGE_TYPES,
          comparatorType: DefaultComparator.EQUALS,
        }
      : condition;
  };
};
